module.exports = __webpack_public_path__ + "img/7-eleven_logo.21413db5.svg";